import IconDrakeMountain from './IconDrakeMountain';

export default IconDrakeMountain;